import './Offering.css'
import OfferingInfo from '../../../models/OfferingInfo'
import { useAppContext } from '../../../util/AppContext';

interface OfferingProps {
    offeringData: OfferingInfo;
    isExpanded: boolean
    onLearnMore: (id: string) => void;
}

function Offering({ offeringData, isExpanded, onLearnMore }: OfferingProps) {

    const { screenWidth } = useAppContext();

    return (
        <div className='offering-container'>
            <div className='offering' >
                <div className='offering-image'>
                    <img src={offeringData.imgSrc} alt="Offering" />
                </div>
                <div className='offering-body'>
                    <h3 className='offering-title'>{offeringData.title}</h3>
                    <p>{offeringData.description}</p>
                    <button className={`button ${isExpanded && 'learn-less'}`}
                        onClick={() => onLearnMore(offeringData.id)}>
                        {isExpanded ? "Learn Less" : "Learn More"}
                    </button>
                </div>
            </div>
            {screenWidth > 1078 && (<span className={`triangle-upside-down ${(!isExpanded) && "triangle-transparent"}`} />)}
        </div>
    )
}

export default Offering